import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import './style.scss'
import { useSelector } from 'react-redux'
import { IsPathActive } from '../../utils/helpers'

const Connection = () => {
    const { pathname } = useLocation()
    const count = useSelector((state) => state.notification)
    const linkClass = ({ isActive }) => isActive ? 'btn shadow-sm isActive' : 'btn shadow-sm'
    // "/connection/" keeps the trailing slash so the page can mark proposals as seen
    const rootActive = IsPathActive(pathname, '/connection/')

    return (
        <div className="custom-navbar">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <NavLink
                            className={`btn shadow-sm ${rootActive ? 'isActive' : ''}`}
                            to="/connection/"
                        >Accepted {count.acceptedProposal > 0 ? <span>{count.acceptedProposal}</span> : null}</NavLink>
                        <NavLink
                            className={linkClass}
                            to="/connection/send"
                        >Send</NavLink>
                        <NavLink
                            className={linkClass}
                            to="/connection/pending"
                        >Pending {count.incomingProposal > 0 ? <span>{count.incomingProposal}</span> : null}</NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Connection;
